import { Component } from '@angular/core';

@Component({
    selector: 'app-proPrincipal',
    templateUrl: './proPrincipal.component.html',
    styleUrls: ['./proPrincipal.component.css']
  })
  export class ProPrincipalComponent{

  }